import { render, staticRenderFns } from "./ProjectActionButtons.vue?vue&type=template&id=194e5b0a&scoped=true"
import script from "./ProjectActionButtons.vue?vue&type=script&lang=js"
export * from "./ProjectActionButtons.vue?vue&type=script&lang=js"
import style0 from "./ProjectActionButtons.vue?vue&type=style&index=0&id=194e5b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e5b0a",
  null
  
)

export default component.exports